export default { sha: '549049e2ea1713414593e69c2b5ce428ef901d67', buildNumber: 'undefined' }
